import { Body, Box, Heading } from '@hover/blueprint';
import React, { useContext } from 'react';

import { Component as EmptyDesign } from 'src/assets/img/empty-design.svg';
import { DesignChanges } from 'src/modules/designStudio/components/DesignChanges';
import { UIKind } from 'src/modules/designStudio/components/DesignStudio/UILayer/types';
import { SlideSmartMenu } from 'src/modules/designStudio/components/Toolbar/SlideSmartMenu';
import type { Menu } from 'src/modules/designStudio/constants';
import { getGuardedLegacyConfig } from 'src/modules/designStudio/helpers/data/TemplateDesignConfig';
import {
  UILayerProvider,
  historyContext,
} from 'src/modules/designStudio/providers';
import { useIsLandscape, useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

interface CurrentDesignCardProps {
  onHeightChange: (currentHeight: number) => void;
  menu: Menu | null;
  toolbarRef: React.RefObject<HTMLElement> | null;
}

const CurrentDesignCard = ({
  onHeightChange,
  menu,
  toolbarRef,
}: CurrentDesignCardProps) => {
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);
  const [isLandscape] = useIsLandscape();

  const { historyState } = useContext(historyContext);

  const designConfig = getGuardedLegacyConfig(historyState.designConfig);

  const isDesignEmpty =
    !designConfig.ROOFS.textureId &&
    !designConfig.WALLS.textureId &&
    !designConfig.WINDOWS.gridType &&
    !designConfig.TRIMS.color;

  return (
    <UILayerProvider kind={isLandscape ? UIKind.LANDSCAPE : UIKind.MOBILE}>
      <SlideSmartMenu
        closeMenu={() => null}
        closeable={false}
        containerRef={toolbarRef}
        menu={menu}
        onHeightChange={onHeightChange}
        testId="current-design-card"
      >
        <Box display="block">
          <Heading size={500} testId="homeowner-design">
            {t('menu.designConfigCard.title')}
          </Heading>
          {isDesignEmpty ? (
            <Box display="grid" justifyContent="center" textAlign="center">
              <Box justifyContent="center" marginBottom={400}>
                <EmptyDesign />
              </Box>
              <Heading size={300} testId="empty-design">
                {t('menu.designConfigCard.emptyDesign')}
              </Heading>
              <Body size={400} testId="empty-design-body">
                {t('menu.designConfigCard.emptyDesignBody')}
              </Body>
            </Box>
          ) : (
            <DesignChanges designConfig={designConfig} />
          )}
        </Box>
      </SlideSmartMenu>
    </UILayerProvider>
  );
};

export { CurrentDesignCard };
